import { IReactComponent } from "mobx-react/dist/types/IReactComponent";
import React, { PureComponent, Suspense } from "react";
import { Provider } from "mobx-react";

class StoreProvider extends PureComponent<{ stores: any }> {
  state = {
    child: null
  }

  componentDidMount() {
    this.setState({ child: this.props.children })
  }

  render() {
    return (
      <Provider weId={`_7j4q6a`} {...this.props.stores}>
        {this.state.child}
      </Provider>
    )
  }
}

function wrap(Com: IReactComponent<any>, stores: { [storeName: string]: any }): IReactComponent<any> {
  let wrap: IReactComponent<any> = React.forwardRef((props, ref) => {
    return (
      <StoreProvider weId={`_7j4q6a`} stores={stores}>
        <Com weId={`_466hav`} ref={ref} {...props} />
      </StoreProvider>
    )
  })
  return wrap;
}

export function withStores(
  stores: { [storeName: string]: any }
): <T extends IReactComponent<any>>(
  target: T
) => T
export function withStores(stores: { [storeName: string]: any }) {
  return (Com: IReactComponent<any>) => wrap(Com, stores)
}